<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  #bottomNav {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: utils.in_rem(8px);
    padding: 0 0 utils.in_rem(12px) utils.in_rem(16px);
    overflow-x: hidden;
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import TrainingHubSidebar from "../../../pages/TrainingHub/Sidebar/Sidebar.svelte";
  import Divider from "../Divider.svelte";
  import UpgradeTrialSidebar from "../UpgradeTrialSidebar/UpgradeTrialSidebar.svelte";
  import ActionItems from "./ActionItems.svelte";
  import ProfileDropdown from "./ProfileDropdown.svelte";
</script>

<div id="bottomNav">
  <Divider />
  {#if $userStore.isPlgTrial}
    <UpgradeTrialSidebar />
  {:else}
    <TrainingHubSidebar />
  {/if}
  <ActionItems />
  <ProfileDropdown />
</div>
